var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackMuteSmall = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-PlaybackMuteSmall Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 32
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "playback-mute-small_svg__a",
  width: 32,
  height: 32,
  x: 0,
  y: 0,
  rx: 4
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "playback-mute-small_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#playback-mute-small_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#playback-mute-small_svg__a",
  fill: "#484848",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#playback-mute-small_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m23.538 13.655.433.542c.052.063.08.15.08.24s-.028.177-.08.24l-1.06 1.322 1.06 1.324c.052.063.08.15.08.24s-.028.177-.08.24l-.433.542c-.105.13-.274.13-.379 0l-1.063-1.327-1.048 1.313c-.105.13-.274.13-.378 0l-.439-.542a.42.42 0 0 1 0-.48L21.281 16l-1.05-1.31a.42.42 0 0 1 0-.48l.439-.54c.104-.13.273-.13.378 0l1.048 1.311 1.063-1.326c.105-.13.274-.13.379 0m-6.01 11.943a.7.7 0 0 1-.307-.076h-.055l-.099-.061-5.138-4.594h-1.645c-.59.001-1.073-.58-1.097-1.316V12.45c.024-.736.508-1.317 1.097-1.316h1.645l5.199-4.614h.055a.9.9 0 0 1 .345-.117.72.72 0 0 1 .6.258c.164.183.262.441.272.716v17.248a1.14 1.14 0 0 1-.272.716.72.72 0 0 1-.6.258m-.614-2.571V8.87l-3.762 3.36v7.465zm-5.254-3.97v-6.17h-.981v6.17z"
}))))));
export default SvgPlaybackMuteSmall;